import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 俱乐部大屏
  {
    path: "/",
    component: () => import("../views/index.vue"),
  },
];

const router = new VueRouter({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
